import {queryOptions} from '@tanstack/react-query';

import {keys} from '@queries/keys';

import {getPayments} from './getPayments';

export const paymentsQueryOptions = (from?: string, to?: string) =>
  queryOptions({
    queryKey: keys.payments.list({from, to}),
    queryFn: () => getPayments(from, to),
    staleTime: 30_000,
  });
